var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,{tag:"component",staticClass:"button-base",class:_vm.classes,attrs:{"disabled":_vm.disabled,"to":_vm.to,"href":_vm.href},on:{"click":function($event){return _vm.click()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }